export default __webpack_public_path__ + "static/media/330_business04-es-mobile.74b4e9e5.png";